import React from 'react';
import Popup from 'reactjs-popup';
import infoIcon from './infoPopupIcon.png';
import './InfoPopup.css';

const InfoPopup = ({ info = '', triggerOn = 'hover' }) => {
  const InfoIcon = (
    <img
      width={22}
      height={24}
      src={infoIcon}
      alt="Info icon"
      className="info-popup-icon"
      style={{ cursor: 'pointer' }}
    />
  );

  return (
    <Popup
      on={triggerOn}
      trigger={() => InfoIcon}
      position="bottom center"
      closeOnDocumentClick
      arrow={false}
    >
      <div className="info-popup-content">{info}</div>
    </Popup>
  );
};

export default InfoPopup;
